module.exports = __webpack_public_path__ + "img/coinbankB23.3cb37d1b.jpg";